import { ReducerAction } from '@keplerco/core';
import { CompanyRoleAssigneesSearchParams } from '../../../models/overmind/search-params';
import { CompanyEntityAssigneeListResponse } from '../../../models/overmind/company-entity';

// state
interface YourCareerPeopleState {
  request: CompanyRoleAssigneesSearchParams | undefined;
  data: CompanyEntityAssigneeListResponse | undefined;
}

export const initialState: YourCareerPeopleState = {
  request: undefined,
  data: undefined,
};

// actions
export enum YourCareerPeopleActionTypes {
  SetData,
  SetRequest,
}

type YourCareerPeopleActions = ReducerAction<YourCareerPeopleActionTypes.SetRequest, { payload: CompanyRoleAssigneesSearchParams }> | ReducerAction<YourCareerPeopleActionTypes.SetData, { payload: CompanyEntityAssigneeListResponse | undefined }>;

// reducer
export function reducer(state: YourCareerPeopleState, action: YourCareerPeopleActions): YourCareerPeopleState {
  if (action.type === YourCareerPeopleActionTypes.SetData) {
    return { ...state, data: action.payload };
  }

  if (action.type === YourCareerPeopleActionTypes.SetRequest) {
    return { ...state, request: action.payload };
  }

  return state;
}
